<template>
  <div class="q-pt-md">

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 q-px-sm">
        <q-toggle
          v-model="redeemAll"
          label="Redeem All Units"
          right-label
          @input="toggleRedeemAll()"
          :disable=disableToggle
        />
        <br />
        <q-slide-transition>
          <small v-show="redeemAll"><strong>* Redeem all is for units tagged to YOUR AGENT CODE only. Please submit manually if you would like to redeem more than this.</strong></small>
        </q-slide-transition>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 q-py-md q-px-sm">
        <div class="text-bold">Fund Name</div>
        <q-field stack-label outlined readonly>
          <template v-slot:control>
            <div class="self-center full-width no-outline text-bold text-primary" tabindex="0">{{ fundName }}</div>
          </template>
        </q-field>
      </div>
    </div>

    <div class="row wrap">

      <div class="col-xs-12 col-sm-12 col-md-6 q-px-sm">
          <div class="text-bold"><span>Redemption Units</span> <small class="float-right">Min: {{ parseNumber(actionRules.minRedemption.toString()) | thousandSeparator }} Units</small></div>
          <div bottom-slots>
            <q-input
              input-class="redemption-input text-primary"
              outlined
              v-model="fValue"
              :readonly="redeemAll"
              lazy-rules
              :rules="[
                val => val !== '0.00' && val !== '' || 'Must enter a valid value.',
                val => parseNumber(val) <= Number(actionRules.maxRedemption.toFixed(2)) || 'Must not exceed ' + parsePrice(actionRules.maxRedemption) + ' units',
                val => parseNumber(val) >= Number(actionRules.minRedemption.toFixed(2)) || redeemAll || 'Must be above ' + parsePrice(actionRules.minRedemption) + ' units'
              ]"
            />
          </div>
      </div>
      
      <div class="col-xs-12 col-sm-12 col-md-6 q-px-sm q-pb-md">
        <div class="text-bold">Balance Units <small class="float-right">Min: {{ parseNumber(actionRules.minUnitBalance.toString()) | thousandSeparator }} Units</small></div>
          <div bottom-slots>
            <q-input
              :input-class="['redemption-input', 'text-primary', { 'text-negative': unitBalance < 0 }]"
              outlined
              stack-label
              readonly
              :value="unitBalance | thousandSeparator"
              :rules="[
                val => (parseNumber(val) >= Number(actionRules.minUnitBalance.toFixed(2)) || parseNumber(val) === '0.00') || 'Must be above ' + parsePrice(actionRules.minUnitBalance) + ' units'
              ]"
            />
          </div>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 q-px-sm q-pb-md">
        <div class="text-bold">Estimated Amount</div>
        <div bottom-slots>
          <q-input
            input-class="redemption-input text-primary"
            outlined
            :value="parsePrice(estimatedAmount)"
            :prefix="currency"
            readonly
          />
        </div>
        <small>* The final redemption amount may be subjected to redemption charges or other related fees etc.</small>
      </div>
      
      <div class="col-xs-12 col-sm-12 col-md-6 q-px-sm">
        <div v-if="plan !== 'EPF'">
          <div class="text-bold">Payment Method</div>
          <div bottom-slots>
            <q-select
              outlined
              :loading="isLoadingBankApplications"
              v-model="paymentMethod"
              :options="paymentMethodList"
              :readonly="bankAccount.optionsList.length !== 0 && plan !== 'EPF'"
              input-class="redemption-input text-primary"
              :rules="[ val => val !== '' || 'Please select a payment method' ]"
            />
          </div>
        </div>

        <div v-if="plan === 'EPF'">
          <div class="text-bold">EPF No <small class="text-red text-align-right float-right">* Will be credited to EPF account</small></div>
          <div bottom-slots>
            <q-input
                v-if="plan === 'EPF'"
                outlined
                label="EPF No"
                readonly
                input-class="redemption-input text-primary"
                :value="this.accountInfo.EPFNo"
            />
          </div>
        </div>
      </div>
    
      <div class="col-xs-12 col-sm-12 col-md-12 q-px-sm">
        <div v-if="plan !== 'EPF' && this.paymentMethodIsTelegrapicTransfer">
          
          <div bottom-slots v-if="this.paymentMethodIsTelegrapicTransfer && bankAccount.optionsList.length > 0">
            <div class="text-bold">Payment Instruction</div>
            <q-select 
              v-if="plan !== 'EPF'"
              outlined
              input-class="redemption-input text-primary"
              v-model="bankAccount.selected"
              :options="bankAccount.optionsList"
              :rules="[ val => val !== '' || 'Please select a payment instruction']"
            />
          </div>

          <div bottom-slots v-if="this.paymentMethodIsTelegrapicTransfer">
            <q-btn color="primary" label="Add New Bank Account" @click="toggleAddNewBankForm()" ></q-btn>
          </div>

        </div>
      </div>

    </div>
    
    <div class="row q-mt-md">
      <q-markup-table flat bordered separator="cell" class="q-ml-sm q-mr-sm" style="width: 100%">
        <tbody>
          <tr>
            <td class="text-primary text-bold" style="width: 25%">REPURCHASE CHARGE</td>
            <td class="q-pa-md"><span v-html="repurchaseCharge"></span></td>
          </tr>
          <tr>
            <td class="text-primary text-bold" style="width: 25%">PENALTY CHARGE</td>
            <td class="q-pa-md"><span v-html="penaltyCharge"></span></td>
          </tr>
        </tbody>
      </q-markup-table>
    </div>

    <q-dialog
      v-model="bankAccount.addNew"
      persistent
      >
        <div style="width: 700px; max-width: 80vw;">
          <add-new-bank
          :customerId=customerId
          :accountId=accountId
          :userId=userId
          :channel=channel
          :currency=currency
          :isSelf=isSelf
          :env="env"
          :apiUrl="apiUrl"
          :notificationAPIToken="notificationAPIToken"
          :onboardingAPIToken="onboardingAPIToken"
          :cifAPIToken="cifAPIToken"
          :agentEmail="agentEmail"
          @submit="addNewBankToList"
          @cancel="toggleAddNewBankForm"
        />
        </div>
    </q-dialog>

  </div>
</template>

<script>
import { QToggle, QInput, QSelect, QDialog } from 'quasar'
import mixins from './mixin'
import AddNewBank from './add-new-bank/AddNewBank.vue'
import axios from 'axios'

export default {

  name: "RedeemAction",

  components: {
    AddNewBank,
    QToggle,
    QInput,
    QSelect,
    QDialog
  },

  mixins: [mixins],

  props: {
    appId: String,
    customerId: String,
    accountId: String,
    userId: String,
    channel: String,
    scheme: String,
    fundName: String,
    plan: String,
    currency: String,
    actionRules: Object,
    isSelf: { type: Boolean, required: false, default: false },

    env: { type: String, required: false, default: 'development' },
    apiUrl: { type: String, required: false },
    notificationAPIToken: { type: String, required: false },
    onelookAPIToken: { type: String, required: true },
    cifAPIToken: { type: String, required: true },
    onboardingAPIToken: { type: String, required: true },
    transactionAPIToken: { type: String, required: true },
    fundAPIToken: { type: String, required: true },

    agentEmail: { type: String, required: true }
  },
  
  data() {
    return {
      inputUnits: '0.00',
      redeemAll: false,
      paymentMethod: '',
      bankAccount: {
        optionsList: [],
        selected: '',
        addNew: false
      },
      customerInfo: [],
      accountInfo: [],
      disableToggle: false,
      bankList: [],
      isLoadingBankApplications: true,
      repurchaseCharge: '',
      penaltyCharge: ''
    };
  },

  methods: {
    
    toggleRedeemAll() {
      this.redeemAll ? this.maxInputUnits() : this.resetInputUnits()
    },

    maxInputUnits() {
      this.redeemAll = true
      this.$set(this, 'inputUnits', this.parsePrice(this.actionRules.maxRedemption))
    },

    resetInputUnits() {
      this.redeemAll = false
      this.$set(this, 'inputUnits', '0.00')
    },

    /** Check if available units is smaller then the allowed minimum redemption unit */
    unitBalanceCheck() {
      if (this.actionRules.maxRedemption < this.actionRules.minRedemption) {
        this.maxInputUnits()
        this.disableToggle = true
      }
    },

    /** Check if customer already have an existing bank account */
    bankAccountCheck() {
      if (this.bankAccount.optionsList.length !== 0 && this.plan !== 'EPF') {
        this.$set(this, 'paymentMethod', this.paymentMethodList[0])
      }
    },

    toggleAddNewBankForm() {
      this.bankAccount.addNew ? this.bankAccount.addNew = false : this.bankAccount.addNew = true
    },

    addNewBankToList(newBank) {
      this.bankAccount.optionsList.push(newBank)
      this.bankAccount.selected = newBank
      this.bankAccount.addNew = false
    }

  },

  computed: {

    unitBalance() {
      return (parseFloat(this.actionRules.maxRedemption) - this.inputUnits.replace(/,/g, "").trim()).toFixed(2)
    },

    estimatedAmount() {
      return (this.inputUnits.replace(/,/g, "").trim() * this.actionRules.nav).toFixed(2)
    },

    fValue: {
        get: function () {
            return this.inputUnits;
        },

        set: function (newValue) {

          if (/[a-zA-Z]/g.test(newValue)) {
            return
          }

          if (newValue.length <= 2) {
              return this.inputUnits = newValue
          }

          newValue = newValue.replace(".", "");

          this.inputUnits = newValue.substr(0, newValue.length - 2) + "." + newValue.substr(newValue.length - 2);
          let num_parts = this.inputUnits.toString().split(".");

          const result = num_parts[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.inputUnits = result + '.' + num_parts[1]
        }
    },

    paymentMethodList() {

      let optionsList;

      if (this.currency === "MYR") 
        optionsList = [{ label: "Telegraphic / Interbank Transfer", value: "TT" }]
      
      else
        optionsList = [{ label: "Foreign Telegraphic / Interbank Transfer", value: "FTT" }]

      if (this.bankAccount.optionsList.length === 0)
        optionsList.push({ label: "Cheque", value: "CQ" })

      return optionsList;
    },

    paymentMethodIsTelegrapicTransfer() {
      return (this.paymentMethod.value === 'TT' || this.paymentMethod.value === 'FTT')
    }

  },

  async mounted() {

    // CIF API : Fetch account information
    axios({
      method: 'GET',
      url: this.apiUrl + '/cif/account/' + this.accountId,
      headers: {
        Authorization: 'Bearer ' + this.cifAPIToken
      }
    })
    .then(resp => {

      this.$set(this, 'accountInfo', resp.data.Account)

      if (this.accountInfo.BankAccounts) {
        let bankList = this.accountInfo.BankAccounts
          .filter(item => item.BankAccountTypeID === "1")
          .filter(item => item.Currency === this.currency)
          .map(item => {
            return {
              label: item.BankName + ' - ' + item.AccountNo,
              value: {
                bankName: item.BankName,
                accHolderName: item.AccountName,
                accNo: item.AccountNo,
                micrCode: item.MICRCode
              }
            }
          })
          
        this.$set(this.bankAccount, 'optionsList', bankList)
      }

    })
    .catch(err => console.log(err))


    // CIF API : Fetch customer information
    await axios({
      method: 'GET',
      url: this.apiUrl + '/cif/' + this.customerId + '/enquiry/customerinformation',
      headers: {
        Authorization: 'Bearer ' + this.cifAPIToken
      }
    })
    .then(resp => {
      this.customerInfo = resp.data.CIF.CustomerDetail
    })
    .catch(err => console.log(err))


    // Onboarding API: Fetch form data
    await axios({
      method: 'GET',
      url: this.apiUrl + '/onboarding/form/lookups',
      headers: {
          Authorization: 'Bearer ' + this.onboardingAPIToken
      }
    })
    .then(resp => {
      this.bankList = resp.data.Bank.map(item => {
        return { label: item.Name, value: item.Value }
      })
    })
    .catch(err => console.log(err))


    // CIF API: Get bank application listing for customer
    axios({
      method: 'GET',
      url: this.apiUrl + '/cif/bankaccountapplication/listing',
      params: {
        customerid: this.customerId
      },
      headers: {
        Authorization: 'Bearer ' + this.cifAPIToken
      }
    })
    .then(resp => {
      if (resp.data.isSuccessful) {
        let newBankApplications = resp.data.BankAccountPost
          .filter(item => item.AccountId.includes(this.accountId))
          .filter(item => item.Currency === this.currency)
          .filter(item => item.Status === 'submitted' || item.Status === 'Pending Verification' || item.Status === 'Processing')
          .map(item => {

            // @TODO: Check this with API team
            let correctBankDetail = this.bankList.filter(v => v.value === item.BankName).reduce((init, v) => v, [])

            return {
              label: correctBankDetail.label + ' - ' + item.BankAccNumber,
              value: {
                bankName: item.BankName,
                accHolderName: item.BankAccName,
                accNo: item.BankAccNumber,
                micrCode: correctBankDetail.value
              }
            }
          })

        let concatenatedBankList = this.bankAccount.optionsList.concat(newBankApplications)
        this.$set(this.bankAccount, 'optionsList', concatenatedBankList)
      }

      // Stop payment method loading state
      this.isLoadingBankApplications = false

      // Force payment method to TT if have existing bank account
      this.$nextTick( () => this.bankAccountCheck() )
    })
    .catch(err => {

      console.log(err)

      // Stop payment method loading state
      this.isLoadingBankApplications = false

      // Force payment method to TT if have existing bank account
      this.$nextTick( () => this.bankAccountCheck() )
    })

    // Fund API: Fetch Penalty & Repurchase Charge
    axios({
      method: 'GET',
      url: this.apiUrl + '/fund/funds',
      params: {
        pschemecode: this.scheme,
      },
      headers: {
          Authorization: 'Bearer ' + this.fundAPIToken
      }
    })
    .then(resp => {
      this.$set(this, 'repurchaseCharge', resp.data.fundsResult[0].Redemptioncost_EN ? resp.data.fundsResult[0].Redemptioncost_EN : 'N/A')
      this.$set(this, 'penaltyCharge', resp.data.fundsResult[0].PenaltyCharge ? resp.data.fundsResult[0].PenaltyCharge : 'N/A')
    })
    .catch(err => console.log(err))

    // Form parameter checker
    this.$nextTick( () => this.unitBalanceCheck() )

  }

};
</script>

<style scope>
.redemption-input { 
  text-align: right;
  font-size: 14px !important;
  font-weight: bold !important;
}

.q-field__messages {
  text-align: right !important;
}

small {
  font-weight: normal !important;
}
</style>
